<template>
  <div class="content">
    <van-nav-bar title="充值"
                 left-text="返回"
                 left-arrow
                 @click-left="onClickLeft" />

    <van-dialog v-model="codeDialog"
                title="请长按识别此二维码进行支付"
                show-cancel-button
                class="payInfo"
                confirmButtonText="已支付"
                cancelButtonText="未支付"
                @confirm="searchPay"
                center>
      <div ref="qrcode"
           id="qrcode"
           class="qrcode"
           style="display:none"></div>
      <div ref="myQrcode"
           class="qrcode"></div>
      <div class="pay_moeny_info">
        <div class="money_title">应付:</div>
        <div class="money_item">￥{{this.money}}</div>
      </div>
    </van-dialog>

    <div class="title">
      <div class="title_info">
        <div class="info_title">账户可用余额</div>
        <div class="info_money"><span class="money_dot">￥</span>{{this.balance}}</div>
      </div>
      <div class="title_history"
           @click="toPayInfo()">
        充值记录 >
      </div>
    </div>

    <div class="room_info">
      <span class="little_title">充值信息</span>
      <div class="room_name">
        <div class="room_title">充值户号:</div>
        <div class="room_address">{{this.roomName}}</div>
      </div>
      <div class="room_name">
        <div class="room_title">充值类型:</div>
        <div class="room_address">{{this.payType == 'SF' ?'水费' : '电费'}}</div>
      </div>
    </div>

    <div class="pay_content">
      <div class="pay_title">充值金额</div>
      <div class="pay_money">
        <div :class="choose == index ? 'money_item_choose' : 'money_item'"
             @click="chooseMoney(item,index)"
             v-for="(item,index) in moneyArray">
          {{item.label}}
        </div>
      </div>
    </div>
    <div class="pay_type">
      <span>请选择支付方式</span>
      <div class="type_content">
        <div class="type_item">
          <van-icon :name="require('../assets/vxPay.png')" />
          <span>微信支付</span>
        </div>
        <van-checkbox v-model="checked"
                      shape="square"
                      @touch="changeType"></van-checkbox>

      </div>
    </div>

    <div class="pay_button">
      <van-button round
                  type="info"
                  color="#04C98B"
                  @click="toPay">立即充值</van-button>
    </div>

    <van-popup v-model="show"
               position="bottom"
               class="_popup"
               safe-area-inset-bottom
               :close-on-click-overlay="!payLoading">
      <div class="popup">
        <p>请输入充值金额</p>
        <div class="popup_money">
          <van-field v-model="money"
                     type="number"
                     input-align="center"
                     placeholder="￥"
                     readonly
                     :max="9999"
                     maxlength=7 />
        </div>

      </div>
      <!-- 自定义金额弹出框 -->
      <van-number-keyboard :show="show"
                           theme="custom"
                           extra-key="."
                           safe-area-inset-bottom
                           close-button-text="充值"
                           @close="toPay"
                           @input="onInput"
                           @delete="onDelete"
                           :close-button-loading="payLoading">
      </van-number-keyboard>
    </van-popup>

  </div>

</template>


<script>
import QRCode from 'qrcodejs2'
export default {
  data() {
    return {
      clockTimer: null,
      payId: '',
      preorderId: '',
      // 二维码弹窗
      codeDialog: false,
      // 二维码
      qrcode: {},
      // 当前默认选中金额
      choose: 0,
      money: '10',
      checked: true,
      // 自定义金额弹出框
      show: false,
      // 自定义充值等待回调
      payLoading: false,
      // 当前充值类型
      payType: '',
      // 当前充值人
      openId: '',
      // 当前充值房间
      roomId: '',
      // 当前充值房间名字
      roomName: '',
      // 当前房间余额
      balance: '0',
      isPayShow: true,
      moneyArray: [
        { label: '10元', value: '10' },
        { label: '30元', value: '30' },
        { label: '50元', value: '50' },
        { label: '100元', value: '100' },
        { label: '300元', value: '300' },
        { label: '自定义金额', value: '0' },
      ]
    }
  },
  mounted() {
    // 进入支付界面之前 先判断一下 是否带有openInfo和绑定的roomId 以及 infoType(选择充值的是电费还是水费) 
    // 如果没有 退回到详情界面。
    this.openInfo = JSON.parse(window.sessionStorage.getItem('openInfo'))
    if (this.openInfo == null || this.openInfo.roomId == null) {
      this.$router.push('/detail')
    } else {
      this.payType = window.sessionStorage.getItem('infoType')
      if (this.payType == null) {
        this.$router.push('/detail')
      } else {
        if (this.payType == 'W') {
          this.payType = 'SF'
        } else if (this.payType == 'E') {
          this.payType = 'DF'
        }
        this.openId = JSON.parse(window.sessionStorage.getItem('openInfo')).openId
        this.roomId = JSON.parse(window.sessionStorage.getItem('openInfo')).roomId
        this.roomName = JSON.parse(window.sessionStorage.getItem('openInfo')).roomName
        this.balance = JSON.parse(window.sessionStorage.getItem('balance'))

        console.log(this.payType, this.openId, this.roomId, this.roomName, this.balance)
      }

    }

  },
  methods: {
    onClickLeft() {
      this.$router.push('/detail')
    },
    chooseMoney(item, index) {
      if (item.value == 0) {
        // 选中高亮
        this.choose = index
        // 打开自定义窗口
        this.show = true
        // 清空选择的钱
        this.money = ''
        return
      }
      console.log(item.value, index)
      this.choose = index
      this.money = item.value

    },
    changeType() {
      this.checked = true
    },
    onInput(string) {
      this.money = this.money + string
      if (this.money.split('.')[1] && this.money.split('.')[1].length > 2) {
        this.money = this.money.split('.')[0] + '.' + this.money.split('.')[1].slice(0, 2)

      }
      console.log(this.money)

    },
    onDelete() {
      let length = this.money.length
      this.money = this.money.slice(0, length - 1)
    },
    toPay() {

      if (this.money == '' || this.money <= 0) {
        this.$notify('充值金额不能为空');
        return
      }
      // 如果上次请求toPay还没完成 拒绝本次支付请求发起
      if (this.payLoading == true) {
        return
      }
      this.payLoading = true
      if (this.clockTimer != null) {
        clearTimeout(this.clockTimer)
      }
      this.$axios.post('/wx/preCreate?openId=' + this.openId + '&payType=' + this.payType + '&price=' + this.money + '&roomId=' + this.roomId).then(res => {
        this.payLoading = false
        this.show = false
        if (res.code == 200) {
          this.codeDialog = true
          this.clock()
          let url = res.object.payurl
          this.payId = res.object.payId
          this.preorderId = res.object.preorderId
          this.$nextTick(() => {
            this.init(url)
          })
        } else {
          this.$toast({
            type: 'fail',
            message: res.message
          })
        }
      }).catch(err => {
        console.log(err)
        this.payLoading = false
        this.codeDialog = false
      })
    },
    clock() {
      this.clockTimer = setTimeout(() => {
        this.$toast({
          type: 'fail',
          message: '订单已超时,请重新发起!'
        })
        this.codeDialog = false
      }, 10 * 60 * 1000);
    },
    // 二维码生成
    init(url) {
      const width = window.innerWidth / 100 * 40
      let qrCodeContent = url
      if (this.qrcode.clear) {
        this.$refs.qrcode.innerHTML = ''
      }
      this.qrcode = new QRCode(this.$refs.qrcode, {
        text: qrCodeContent, //二维码内容字符串
        width: width, //图像宽度
        height: width, //图像高度
        colorDark: '#000000', //二维码前景色
        colorLight: '#ffffff', //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错级别,
      })
      var canvas = document.getElementsByTagName('canvas')[0]
      var img = this.canvasToImage(canvas)
      this.$refs.myQrcode.innerHTML = ''
      this.$refs.myQrcode.append(img)
    },
    canvasToImage(canvas) {
      var image = new Image()
      image.src = canvas.toDataURL('image/png');
      return image
    },
    searchPay() {
      this.$axios.post('/wx/preOrderQuery?payId=' + this.payId + '&preorderId=' + this.preorderId).then(res => {
        console.log(res)
        if (res.code == 200) {
          window.sessionStorage.setItem('money', this.money)
          window.sessionStorage.setItem('orderTime', res.message)
          this.$router.push('/pay-success')

        } else {
          this.$toast({
            message: '未支付成功或充值系统延时,请稍后到充值记录中查询',
            duration: 4000
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    toPayInfo() {
      this.$router.push('/pay-info')
    }
  }
}
</script>

<style scoped lang="less" >
.title {
  background: rgb(4, 201, 139);
  background: linear-gradient(
    90deg,
    rgba(4, 201, 139, 1) 0%,
    rgba(56, 219, 168, 0.9202988516137481) 100%
  );
  margin: 15px 10px 10px 10px;
  height: 80px;
  border-radius: 10px;
  text-align: start;
  padding: 20px;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info_title {
  font-size: 16px;
  font-weight: 500;
  color: white;
}

.info_money {
  font-size: 28px;
  color: white;
  font-weight: 700;
  letter-spacing: 2px;
}

.money_dot {
  font-size: 18px;
}

.title_history {
  color: white;
  font-weight: 500;
}

.room_info {
  text-align: start;
  margin: 15px 10px 0 10px;
  font-weight: 500;
}

.little_title {
  display: block;
  margin-bottom: 5px;
}

.room_name {
  // border: 1px solid #ddd6d6;
  // box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
  // border-radius: 3px;
  padding: 0 10px;
  height: 40px;
  // border-bottom: 1px solid rgb(182, 176, 176);
  // border-radius: 5px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.room_title {
  color: #a4a1a1;
}

// 充值栏目
.pay_content {
  border-radius: 5px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);

  margin: 10px;
  padding: 10px;
  text-align: start;
  height: 180px;
  background: white;

  .pay_title {
    font-weight: 600;
    margin-bottom: 5px;
  }

  .pay_money {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .money_item {
      border-radius: 8px;
      background: #e8fdf1;
      width: 30%;
      height: 70px;
      margin: 3px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #14b276;
      font-weight: 600;
      font-size: 16px;
    }

    .money_item_choose {
      border-radius: 8px;
      background: #04c98b;
      width: 30%;
      height: 70px;
      margin: 3px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      font-weight: 600;
      font-size: 16px;
    }
  }
}

.pay_type {
  text-align: start;
  margin: 15px 10px 0 10px;
  font-weight: 500;

  .type_content {
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    margin-top: 5px;
    padding: 0 10px;
    height: 40px;
    font-size: 18px;
    border-radius: 5px;
    background: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .type_item {
    display: flex;
    align-items: center;

    span {
      font-size: 18px;
      margin-left: 5px;
    }
  }
}

.pay_button .van-button {
  margin-top: 20px;
  width: 90%;
  height: 35px;
}

._popup {
  height: 320px;
}

/*密码输入框*/
.popup {
  margin-top: 5px;
  width: 100%;
  height: 100%;
  // border-radius: 7px;
  height: 50px;
  // line-height: 50px;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #333;

  p {
    margin: 0;
  }

  .popup_money {
    display: flex;
    align-items: center;
    margin-top: 10px;
  }

  .van-cell {
    padding: 0;
    padding: 0 10px;
    font-size: 20px;
  }
}

.van-number-keyboard {
  height: 220px;
}

.payInfo {
  .pay_moeny_info {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .money_title {
    color: #a09a9a;
    margin-top: 5px;
    margin-right: 5px;
  }

  .money_item {
    color: #00c170;
    font-size: 30px;
  }

  .qrcode {
    padding: 15px 15px 10px 15px;
  }
}

#qrcode {
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 30px;
}
</style>